
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reinigung",
      function () {
        return require("private-next-pages/reinigung.tsx");
      }
    ]);
  